import { render, staticRenderFns } from "./PartSpotlight.vue?vue&type=template&id=a8c3e37a"
import script from "./PartSpotlight.vue?vue&type=script&lang=js"
export * from "./PartSpotlight.vue?vue&type=script&lang=js"
import style0 from "./PartSpotlight.vue?vue&type=style&index=0&id=a8c3e37a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports